var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMentionIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Mention_icon_svg__clip0_2002_413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M594.286 227.619H405.714c-121.5 0-220 98.5-220 220s98.5 220 220 220h65.584c9.738 0 16.142 10.286 11.714 18.953-11 21.571-26.845 40.261-46.083 54.642-13.227 9.881-6.203 31.108 10.297 31.167h.548c65.464 0 121.571-40.036 145.178-96.964 1.953-4.715 6.488-7.81 11.584-8.048 116.738-5.357 209.738-101.69 209.738-219.75 0-121.5-98.5-220-220-220h.012z",
    fill: "#CFFAFF",
    stroke: "#95C2C7",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.464 333.702c-33.166-40.726-83.678-66.797-140.178-66.797H405.714c-56.5 0-107.012 26.071-140.178 66.797",
    stroke: "#fff",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.476 317.452l19.869 61.167a23.628 23.628 0 0022.476 16.322h64.31c22.893 0 32.405 29.285 13.893 42.75l-52.036 37.797a23.611 23.611 0 00-8.583 26.417l19.869 61.166c7.071 21.774-17.845 39.87-36.357 26.417l-52.036-37.797c-8.286-6.012-19.5-6.012-27.774 0l-52.036 37.797c-18.523 13.453-43.428-4.643-36.357-26.417l19.869-61.166A23.611 23.611 0 00409 475.488l-52.036-37.797c-18.524-13.453-9-42.75 13.893-42.75h64.31a23.643 23.643 0 0022.476-16.322l19.869-61.167c7.071-21.773 37.869-21.773 44.94 0h.024z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 16,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500 463.321c9.44 0 18.143 3.119 25.143 8.393 6.94 5.214 16.786.167 16.75-8.512 0-1.071-.048-2.155-.131-3.238-1.607-20.536-18.333-37.071-38.881-38.44-24.452-1.643-44.786 17.714-44.786 41.809v.226c.048 8.524 9.941 13.286 16.75 8.167 7-5.274 15.715-8.393 25.155-8.393v-.012z",
    fill: "#FEDF5B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Mention_icon_svg__clip0_2002_413"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1000v1000H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentionIcon);
export default ForwardRef;